export default __webpack_public_path__ + "static/media/Jerkin of the Masquer of the Sands.b5e2a327.jpg";